import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import Footer from '../components/Footer';
import { ArrowLeft, PaperPlaneTilt, Eye, EyeSlash } from '@phosphor-icons/react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
      <div className="flex-1 flex items-center justify-center px-5 py-10 sm:p-8">
        <div className="w-full max-w-md space-y-6 animate-entrance">
          <div className="flex items-center justify-center mb-4">
            <span className="text-2xl brand-name">Zelvrix</span>
          </div>

          {!sent ? (
            <>
              <div className="text-center">
                <h2 className="text-2xl sm:text-3xl font-bold text-[#1D1D1F]">Forgot password?</h2>
                <p className="mt-2 text-sm text-[#86868B]">Enter your email and we'll send you a reset link.</p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5">
                {error && (
                  <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 text-sm rounded-xl" data-testid="forgot-error">
                    {error}
                  </div>
                )}
                <div className="space-y-2">
                  <Label htmlFor="email" className="text-[#1D1D1F] font-medium text-sm">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@company.com"
                    required
                    autoComplete="email"
                    inputMode="email"
                    className="input-base h-12 rounded-xl text-base"
                    data-testid="forgot-email-input"
                  />
                </div>
                <Button
                  type="submit"
                  disabled={loading}
                  className="w-full btn-primary h-12 rounded-xl text-base"
                  data-testid="forgot-submit-btn"
                >
                  {loading ? 'Sending...' : 'Send reset link'}
                  {!loading && <PaperPlaneTilt size={20} className="ml-2" />}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center space-y-4" data-testid="forgot-success">
              <div className="w-16 h-16 bg-[#34C759]/10 rounded-full flex items-center justify-center mx-auto">
                <PaperPlaneTilt size={32} className="text-[#34C759]" />
              </div>
              <h2 className="text-2xl font-bold text-[#1D1D1F]">Check your email</h2>
              <p className="text-sm text-[#86868B] max-w-sm mx-auto">
                If an account exists for <strong className="text-[#1D1D1F]">{email}</strong>, we've sent a password reset link. Check your inbox and spam folder.
              </p>
            </div>
          )}

          <p className="text-center text-sm text-[#86868B]">
            <Link to="/login" className="text-[#007AFF] font-medium hover:underline inline-flex items-center gap-1" data-testid="back-to-login">
              <ArrowLeft size={16} /> Back to sign in
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
